__turbopack_context__.v({
  "className": "ancizar_serif_f3fd5f9-module__r_iRRG__className",
  "variable": "ancizar_serif_f3fd5f9-module__r_iRRG__variable",
});
